var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "h3",
        { staticClass: "primary--text" },
        [
          _c("v-icon", { attrs: { color: "primary" } }, [_vm._v("people")]),
          _vm._v("\n    Ficha personal\n  ")
        ],
        1
      ),
      _vm._v(" "),
      _vm.persona === null
        ? _c(
            "v-card",
            { attrs: { elevation: "0" } },
            [
              _c(
                "v-card-text",
                { staticClass: "text-md-center" },
                [
                  _c("v-progress-circular", {
                    attrs: {
                      size: 70,
                      width: 7,
                      color: "primary",
                      indeterminate: ""
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.persona !== null
        ? _c(
            "v-card",
            { attrs: { elevation: "0" } },
            [
              _c(
                "v-card-text",
                [
                  _c("p", [
                    _c("strong", [_vm._v("Nombre completo: ")]),
                    _vm._v(
                      _vm._s(_vm.persona.nombres) +
                        " " +
                        _vm._s(_vm.persona.ap_paterno) +
                        " " +
                        _vm._s(_vm.persona.ap_materno)
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("strong", [_vm._v("Número de documento: ")]),
                    _vm._v(_vm._s(_vm.persona.nro_doc))
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("strong", [_vm._v("Sexo: ")]),
                    _vm._v(_vm._s(_vm.recuperarSexo(_vm.persona.id_genero)))
                  ]),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { md3: "" } }, [
                    _vm._v("Foto\n        "),
                    _c("div", { attrs: { id: "preview" } }, [
                      _vm.img_url
                        ? _c("img", {
                            attrs: {
                              src: _vm.img_url,
                              height: "150",
                              width: "150"
                            }
                          })
                        : _vm._e()
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-tabs",
                    {
                      staticClass: "tab-preferencias",
                      attrs: {
                        color: "info",
                        dark: "",
                        "slider-color": "warning",
                        "show-arrows": ""
                      },
                      model: {
                        value: _vm.active,
                        callback: function($$v) {
                          _vm.active = $$v
                        },
                        expression: "active"
                      }
                    },
                    [
                      _c(
                        "v-tab",
                        {
                          key: "datos-personales-basicos",
                          attrs: {
                            href: "#datos-personales-basicos",
                            ripple: ""
                          }
                        },
                        [
                          _vm._v(
                            "\n          Datos personales Básicos\n        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab",
                        { key: "cas", attrs: { href: "#cas", ripple: "" } },
                        [
                          _vm._v(
                            " \n          Calificacion de Años de Servicio"
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab",
                        {
                          key: "declaracion-jurada",
                          attrs: { href: "#declaracion-jurada", ripple: "" }
                        },
                        [_vm._v("\n          Declaracion jurada\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab",
                        {
                          key: "inamovilidad",
                          attrs: { href: "#inamovilidad", ripple: "" }
                        },
                        [_vm._v("\n          Inamovilidad\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab",
                        {
                          key: "datos-familiares",
                          attrs: { href: "#datos-familiares", ripple: "" }
                        },
                        [_vm._v("\n          Datos familiares\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab",
                        {
                          key: "formacion-academica",
                          attrs: { href: "#formacion-academica", ripple: "" }
                        },
                        [_vm._v("\n          Formación\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab",
                        {
                          key: "experiencia-trabajo",
                          attrs: { href: "#experiencia-trabajo", ripple: "" }
                        },
                        [_vm._v("\n          Experiencia de trabajo\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab",
                        {
                          key: "cursos-capacitacion",
                          attrs: { href: "#cursos-capacitacion", ripple: "" }
                        },
                        [_vm._v("\n          Cursos de capacitación\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab",
                        {
                          key: "idiomas",
                          attrs: { href: "#idiomas", ripple: "" }
                        },
                        [_vm._v(" Idiomas ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab",
                        {
                          key: "documentos-adjuntos",
                          attrs: {
                            href: "#documentos-adjuntos",
                            ripple: "",
                            "prev-icon": "$vuetify.icons.prev"
                          }
                        },
                        [_vm._v("\n          Documentos adjuntos\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab",
                        {
                          key: "observaciones",
                          attrs: {
                            href: "#observaciones",
                            ripple: "",
                            "prev-icon": "$vuetify.icons.prev"
                          }
                        },
                        [
                          _vm._v(
                            "\n          \n          Observaciones \n         \n        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab",
                        {
                          key: "finalizar",
                          attrs: {
                            href: "#finalizar",
                            ripple: "",
                            "prev-icon": "$vuetify.icons.prev"
                          }
                        },
                        [_vm._v("\n          Finalizar\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        {
                          key: "datos-personales-basicos",
                          attrs: { value: "datos-personales-basicos" }
                        },
                        [
                          _c(
                            "v-card",
                            { attrs: { flat: "" } },
                            [
                              _vm.active == "datos-personales-basicos"
                                ? _c("datos-personales-basicos", {
                                    attrs: { persona: _vm.persona }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        { key: "cas", attrs: { value: "cas" } },
                        [
                          _c(
                            "v-card",
                            { attrs: { flat: "" } },
                            [
                              _vm.active == "cas"
                                ? _c("cas", { attrs: { persona: _vm.persona } })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        {
                          key: "declaracion-jurada",
                          attrs: { value: "declaracion-jurada" }
                        },
                        [
                          _c(
                            "v-card",
                            { attrs: { flat: "" } },
                            [
                              _vm.active == "declaracion-jurada"
                                ? _c("declaracion-jurada", {
                                    attrs: { persona: _vm.persona }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        {
                          key: "inamovilidad",
                          attrs: { value: "inamovilidad" }
                        },
                        [
                          _c(
                            "v-card",
                            { attrs: { flat: "" } },
                            [
                              _vm.active == "inamovilidad"
                                ? _c("inamovilidad", {
                                    attrs: { persona: _vm.persona }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        {
                          key: "datos-familiares",
                          attrs: { value: "datos-familiares" }
                        },
                        [
                          _c(
                            "v-card",
                            { attrs: { flat: "" } },
                            [
                              _vm.active == "datos-familiares"
                                ? _c("datos-familiares", {
                                    attrs: { persona: _vm.persona }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        {
                          key: "formacion-academica",
                          attrs: { value: "formacion-academica" }
                        },
                        [
                          _c(
                            "v-card",
                            { attrs: { flat: "" } },
                            [
                              _vm.active == "formacion-academica"
                                ? _c("formacion-academica", {
                                    attrs: { persona: _vm.persona }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        {
                          key: "experiencia-trabajo",
                          attrs: { value: "experiencia-trabajo" }
                        },
                        [
                          _c(
                            "v-card",
                            { attrs: { flat: "" } },
                            [
                              _vm.active == "experiencia-trabajo"
                                ? _c("experiencia-trabajo", {
                                    attrs: { persona: _vm.persona }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        {
                          key: "cursos-capacitacion",
                          attrs: { value: "cursos-capacitacion" }
                        },
                        [
                          _c(
                            "v-card",
                            { attrs: { flat: "" } },
                            [
                              _vm.active == "cursos-capacitacion"
                                ? _c("cursos-capacitacion", {
                                    attrs: { persona: _vm.persona }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        { key: "idiomas", attrs: { value: "idiomas" } },
                        [
                          _c(
                            "v-card",
                            { attrs: { flat: "" } },
                            [
                              _vm.active == "idiomas"
                                ? _c("idiomas", {
                                    attrs: { persona: _vm.persona }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        {
                          key: "documentos-adjuntos",
                          attrs: { value: "documentos-adjuntos" }
                        },
                        [
                          _c(
                            "v-card",
                            { attrs: { flat: "" } },
                            [
                              _vm.active == "documentos-adjuntos"
                                ? _c("documentos-adjuntos", {
                                    attrs: { persona: _vm.persona }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        {
                          key: "observaciones",
                          attrs: { value: "observaciones" }
                        },
                        [
                          _c(
                            "v-card",
                            { attrs: { flat: "" } },
                            [
                              _vm.active == "observaciones"
                                ? _c("observaciones", {
                                    attrs: { persona: _vm.persona }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        { key: "finalizar", attrs: { value: "finalizar" } },
                        [
                          _c(
                            "v-card",
                            { attrs: { flat: "" } },
                            [
                              _vm.active == "finalizar"
                                ? _c("finalizar", {
                                    attrs: { persona: _vm.persona }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e84b3f0e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e84b3f0e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/ficha_personal/Index.vue
// module id = null
// module chunks = 